// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GlQvb","error":"styles_error__WyD+f"};